import React, { useMemo } from 'react';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getPeriodQuery } from '../../../slices/period/thunk';
import { Badge } from '@mantine/core';

const PeriodList = ({ fiscalYearId }) => {
	const columns = useMemo(
		() => [
			{
				header: 'Nombre',
				accessorKey: 'name',
				align: 'center',
				titlecase: true,
			},
			{
				header: 'Estado',
				accessorKey: 'period_type',
				align: 'center',
				Cell: ({ cell }) => {
					let status = cell.getValue();

					let statusConfig = {
						closed: {
							name: 'Cerrado',
							color: 'red',
						},
						open: {
							name: 'En Curso',
							color: 'green',
						},
						ongoing: {
							name: 'Sin Iniciar',
							color: 'gray',
						},
					};

					return (
						<Badge color={statusConfig[status].color}>
							{statusConfig[status].name}
						</Badge>
					);
				},
			},
			{
				header: 'Nombre Corto',
				accessorKey: 'short_name',
				align: 'center',
			},
			{
				header: 'Trimestre',
				accessorKey: 'quarter',
				align: 'center',
				titlecase: true,
			},
			{
				header: 'Fecha de Inicio',
				accessorKey: 'start_date',
				dataType: 'date',
				align: 'center',
			},
			{
				header: 'Fecha de Fin',
				accessorKey: 'end_date',
				dataType: 'date',
				align: 'center',
			},
		],
		[]
	);

	return (
		<div style={{ padding: '20px' }}>
			<ODataGrid
				theme='minimal'
				columns={columns}
				getDataFunc={getPeriodQuery}
				remoteOperations={{
					pagination: true,
					sorting: true,
					filtering: true,
				}}
				baseFilters={{
					fiscal_year_id: {
						$eq: fiscalYearId,
					},
					disable: {
						$eq: false,
					},
				}}
				nameFile={`periodos_${fiscalYearId}`}
			/>
		</div>
	);
};

export default PeriodList;
